import { ServiceMode } from 'state/service-mode/types';

export const serviceModeList = [
  ServiceMode.TAKEOUT,
  ServiceMode.DRIVE_THRU,
  ServiceMode.CURBSIDE,
  ServiceMode.EAT_IN,
];
